const doc = [({"da":({"js":({"admin":({"orders":({"show":({"show_order":"Vis ordre %{order_number}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;